import { createTheme } from '@mui/material/styles';

export const baseTheme = createTheme({
  palette: {
    primary: {
      main: '#a0c300', // Base color
      light: 'rgba(160, 195, 0, 0.15)', // Lighter shade
      dark: '#758900', // Darker shade
      contrastText: '#ffffff', // White for buttons and text
    },
    secondary: {
      main: '#4E657B', // Complementary purple
      light: '#a670d5', // Lighter shade of purple
      dark: '#43006e', // Darker shade of purple
      contrastText: '#ffffff', // White for contrast
    },
    error: {
      main: '#d32f2f', // Standard red
      light: 'rgba(211, 47, 47, 0.15)', // Much lighter transparent version of error.main
      dark: '#9a0007',
    },
    warning: {
      main: '#ffa000', // Amber
      light: '#ffd740',
      dark: '#c67100',
    },
    info: {
      main: '#1976d2', // Blue
      light: '#63a4ff',
      dark: '#004ba0',
    },
    success: {
      main: '#2e7d32', // Green
      light: '#60ad5e',
      dark: '#005005',
    },
    background: {
      default: '#f5f5f5', // Neutral background
      paper: '#ffffff',
    },
    text: {
      primary: '#333333', // Dark gray for readability
      secondary: '#666666', // Light gray for subdued text
      disabled: '#9e9e9e',
    },
  },
  typography: {
    fontFamily: '"Barlow", sans-serif',
    
  },
});
export const RycIsTheme = createTheme({
  ...baseTheme,
  typography: {
    fontFamily: '"Barlow", sans-serif',
    allVariants: {
      color: baseTheme.palette.secondary.main,
    },
    
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    }
  }
});
